module.exports = __webpack_public_path__ + "static/media/AcknowledgementMarkdown.ff8f4c40.md";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Misc/Contents/AcknowledgementMarkdown.md
// module id = 957
// module chunks = 0